export function setData(key, data) {
	localStorage.setItem(key, JSON.stringify(data))
}

export function getData(key) {
	try {
		const data = localStorage.getItem(key)
		return data && JSON.parse(data)
	} catch (err) {
		console.error(err.message)
	}
}
export function getI18nextLng(key) {
	try {
		const data = localStorage.getItem(key)
		return data
	} catch (err) {
		console.error(err.message)
	}
}

export function removeData(key) {
	localStorage.removeItem(key)
}

export function getUserinfo() {
	return getData('userInfo')
}
export function getLanguage() {
	return getI18nextLng('i18nextLng')
}

export function getAccessToken() {
	try {
		const userInfo = getData('userInfo')
		return userInfo.accessToken
	} catch (err) {
		console.error(err.message)
	}
}

export function saveUserInfo(data) {
	setData('userInfo', data)
}

export function savePathLoginApplao(path) {
	setData('path', path)
}

export function destroyUser() {
	removeData('userInfo')
}

export function removeModal() {
	removeData('hasShownSubModal')
	removeData('isPopupShownPackage_T10-2025')
}
